"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormValidationOverlay = _interopRequireDefault(require("./_FormValidationOverlay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _input = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _input.default);
/** A **FormInput** is used to collect data from the user. When a field is required,
the \`required\` property will include an asterisk (*). */

var FormInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      compact = _ref.compact,
      disabled = _ref.disabled,
      name = _ref.name,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      type = _ref.type,
      value = _ref.value,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "cssNamespace", "compact", "disabled", "name", "placeholder", "readOnly", "type", "value", "validationOverlayProps", "validationState"]);
  var formInputClasses = classnames("".concat(cssNamespace, "-input"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-input--compact"), !!compact), (0, _defineProperty2.default)(_classnames, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), _classnames), className);

  var formInput = /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, props, {
    className: formInputClasses,
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    type: type,
    value: value
  }));

  return validationState ? /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
    control: formInput,
    validationState: validationState
  })) : formInput;
});

FormInput.displayName = 'FormInput';
process.env.NODE_ENV !== "production" ? FormInput.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `name` attribute on the input */
  name: _propTypes.default.string,

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,

  /** Set to **true** to mark component as readonly */
  readOnly: _propTypes.default.bool,

  /** Value for the `type` attribute on the input */
  type: _propTypes.default.string,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Value for the `value` attribute on the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : void 0;
FormInput.defaultProps = {
  type: 'text'
};

var _default = (0, _withStyles.default)(FormInput);

exports.default = _default;